'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _TransmuteCollection = require('./TransmuteCollection');

_TransmuteCollection.clear.implement(Array, function () {
  return [];
});
_TransmuteCollection.clear.implementInherited(_immutable.Collection, function (subject) {
  return subject.clear();
});
_TransmuteCollection.clear.implementInherited(_immutable.Seq, function (seq) {
  if (_immutable.Iterable.isKeyed(seq)) {
    return _immutable.Seq.Keyed();
  }
  if (_immutable.Iterable.isIndexed(seq)) {
    return _immutable.Seq.Indexed();
  }
  return _immutable.Seq.Set();
});
_TransmuteCollection.clear.implement(Object, function () {
  return {};
});

exports.default = _TransmuteCollection.clear;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/internal/_clear.js
// module id = 359
// module chunks = 0 1